import { PrinterInfo } from './PrinterInfo'

export default PrinterInfo
